import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useGlobalContext } from "../Config";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import FormCrearComboProductos from "../components/FormCrearComboProductos";  
import FormCrearProducto from "../components/FormCrearProducto";
import FormEditarProducto from "../components/FormEditarProducto";
import TableProductos from "../components/TableProductos";
import FormCrearProductoSubproducto from "../components/FormCrearProductoSubproducto";
import Loader from "../components/Loader.js";
import { Toast } from 'primereact/toast';

const MantenedorProductos = () => {
  const toast = useRef(null);
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loadingInicial, setLoadingInicial] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [displayDialog, setDisplayDialog] = useState(false);
  const [displayDialogCombinatoria, setDisplayDialogCombinatoria] = useState(false);
  const [displayDialogProductoSubproducto, setDisplayDialogProductoSubproducto] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [id, setId] = useState("");
  const [metraje, setMetraje] = useState("");
  const [idTipo, setIdTipo] = useState("");
  const [union, setUnion] = useState("");
  const [adyacentes, setAdyacentes] = useState([]); 
  const { baseUrl, urlMedidores, headerText } = useGlobalContext();
  const fichaRef = useRef(null);
  const [productoCombinado, setProductoCombinado] = useState({
      tipoProducto: "",
      productos: [],
      descripcionCombinada: "",
      metraje: ""
    });
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const idUsuario = sessionStorage.getItem("usuario_id");
  const [empresa, setEmpresas] = useState(null);
  const [listaEmpresas, setListaEmpresas] = useState([]);
  const obtenerEmpresas = async () => {
    try {
      const response = await fetch(`${baseUrl}/getAllEmpresas`);
      const data = await response.json();
      setListaEmpresas(data.empresas); 
    } catch (error) {
      console.error("Error al obtener las empresas:", error);
    }
  };
  const nombreEmpresa = listaEmpresas.find(item => item.id === empresa)?.nombre;
  const [tipoProductoOptions, setTipoProductoOptions] = useState([]);
  const [producto, setProducto] = useState({
    descripcion: "",
    metraje: "",
    tipoProducto: "",
  });

  const fetchTipoProductoByEmpresa = async () => {
    try {
      const response = await fetch(
        `${baseUrl}getTiposProductoByEmpresa?empresa=${nombreEmpresa}`
      );
      const data = await response.json();
      setTipoProductoOptions(data.tiposProductos); // Assuming tiposProductos is the key in the response
    } catch (error) {
      console.error("Error fetching tipo_producto:", error);
    }
  };

  const fetchData = async () => {
    try {
      if (empresa) {
        setLoadingInicial(true);
        try {
          const response = await fetch(
            `${baseUrl}getProductosByEmpresa?empresa=${nombreEmpresa}`
          );
          const data = await response.json();
          setProductos(data.productos);
        } catch (error) {
          console.error("Error fetching productos:", error);
        } finally {
          setLoadingInicial(false);
        }
      }
    } catch (error) {
      console.error("Error al obtener los productos:", error);
    }
  };
  
  const handleSaveProducto = async () => {
    try {
      setLoading(true);
      const updatedProduct = { 
        ...selectedProduct, 
        idTipo: producto.tipoProducto.id,
        descripcion, 
        metraje,
      };
      await saveProductAPI(updatedProduct);

      // Si existen productos vecino crear pasando el array del productos adyacentes del form y id del nuevo producto
      if (adyacentes && adyacentes.length > 0) {
        const productosAdyacentes = {
          idProducto: updatedProduct.id,
          productos: adyacentes.map(prod => prod.id),
        };
        await updateProductAdyacenteAPI(productosAdyacentes);
      } else {
        await deshabilitarProductAdyacenteAPI({ idProducto: updatedProduct.id });
      }

       // Actualizar la ficha del producto si existe fichaRef
      if (fichaRef && fichaRef.current) {
        const fichaData = fichaRef.current.getData();
        const requestBody = {
          idProducto: updatedProduct.id,
          perfil: fichaData.perfil,
          ficha: fichaData.fichaJson
        };
        
        const responseFicha = await fetch(`${baseUrl}updateProductoFicha`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "Accept": "application/json; charset=UTF-8"
          },
          body: JSON.stringify(requestBody),
        });
        
        if (!responseFicha.ok) {
          throw new Error("Error al actualizar la ficha del producto");
        }
      }
      
      setProducto({ descripcion: "", metraje: "", tipoProducto: "" });
      setShowEditDialog(false);
      fetchData();
    } catch (error) {
      console.error("Error al actualizar el producto:", error);
    } finally {
      toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Producto actualizado exitosamente.', life: 3000 });
    }

  };

  const saveProductAPI = async (producto) => {
    const response = await fetch(`${baseUrl}updateProducto`, {
      method: "PUT",
      headers: headerText,
      body: JSON.stringify(producto),
    });
    if (!response.ok) {
      throw new Error("Error saving the product");
    }
    return await response.json();
  };

  const handleEditProducto = (producto) => {
    setSelectedProduct(producto);
    setDescripcion(producto.descripcion);
    setId(producto.id);
    setMetraje(producto.metraje);
    setIdTipo(producto.idTipo);
    setUnion(producto.combo.combinado);
    // Validación más robusta para productos adyacentes
    let adyacentesArray = [];
    if (producto.adyacentes) {
      if (Array.isArray(producto.adyacentes)) {
        adyacentesArray = producto.adyacentes;
      } else if (producto.adyacentes.lista && Array.isArray(producto.adyacentes.lista)) {
        adyacentesArray = producto.adyacentes.lista;
      }
    }
    setAdyacentes(adyacentesArray);
    setShowEditDialog(true);
  };

  const validateInputs = () => {
    if (!producto.descripcion || !producto.metraje || !producto.tipoProducto) {
      alert("Todos los campos son obligatorios.");
      return false;
    }
    const invalidChars = /[|°!"#$%&/()='?¿¡{}]/;
    if (invalidChars.test(producto.descripcion)) {
      alert("La descripción no debe contener caracteres especiales");
      return false;
    }
    const metrajeNum = parseFloat(producto.metraje);
    if (isNaN(metrajeNum) || metrajeNum <= 0) {
      alert("El metraje debe ser un número mayor a 0.");
      return false;
    }

    // Validación: no permitir crear productos con misma descripción y tipo
    const descNormalized = (producto.descripcion || "")
      .trim()
      .normalize("NFC")
      .toLocaleUpperCase("es-ES");

    const tipoValue =
      typeof producto.tipoProducto === "string"
        ? producto.tipoProducto
        : producto.tipoProducto?.descripcion || "";
    const tipoNormalized = tipoValue.trim().toLowerCase();

    const existeDuplicado = productos.some((p) => {
      const pDesc = p.descripcion
          ? p.descripcion.trim().normalize("NFC").toLocaleUpperCase("es-ES")
          : "";
      const pTipoValue =
        typeof p.tipoProducto === "string"
          ? p.tipoProducto
          : p.tipoProducto?.descripcion || "";
      const pTipo = pTipoValue.trim().toLowerCase();

      return (pDesc === descNormalized && pTipo === tipoNormalized
      );
    });

    if (existeDuplicado) {
      alert("Ya existe un producto con esa descripción y tipo.");
      setLoading(false);
      return;
    }

    return true;
  };

  const handleCreateProducto = async () => {
    if (!validateInputs()) {
      return;
    }
    try{
      setLoading(true);
      setLoading3(true);

      //crear producto en bodegas y medidores
      const newProducto = {
        empresa: nombreEmpresa,
        descripcion: producto.descripcion,
        metraje: producto.metraje,
        idTipoProducto: producto.tipoProducto.id,
      };
      
      // Esperar el resultado y obtener el ID del producto creado
      const resultadoCreacion = await createProductAPI(newProducto);
      const idProductoCreado = resultadoCreacion.producto.id;
      
      //si existen productos vecino crear pasando el array del productos adyacentes del form y id del nuevo producto
      if (producto.productosAdyacentes && producto.productosAdyacentes.length > 0) {
        const productosAdyacentes = {
          idProducto: idProductoCreado,
          productos: producto.productosAdyacentes.map(prod => prod.id),
        };

        await createProductAdyacenteAPI(productosAdyacentes);
      }
      
      setProducto({ descripcion: "", metraje: "", tipoProducto: "" });
      return resultadoCreacion;
    }catch (error) {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al crear producto", life: 3000 });
      setLoading(false);
      return null;
    }finally{
      fetchData();
      setLoading3(false);
      toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Producto creado exitosamente.', life: 3000 });
    }
  };

  const createProductAPI = async ({
    empresa,
    descripcion,
    metraje,
    idTipoProducto
  }) => {
    try {
      const queryParams = new URLSearchParams({
        empresa,
        descripcion,
        metraje: metraje.toString(),
        idTipoProducto: idTipoProducto.toString(),
        idUsuario: idUsuario
      });

      const response = await fetch(
        `${baseUrl}createProducto?${queryParams.toString()}`,
        {
          method: "POST",
          headers: headerText,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.mensaje || "Error al crear producto");
      }
      
      const insertedProducto = data.producto;
      const domicilioBody = {
        codigo: insertedProducto.codigo,
        descripcion: insertedProducto.descripcion,
        direccion: "Sin Dirección",
      };
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json;charset=UTF-8");

      const insertarDomicilioResponse = await fetch(
        `${urlMedidores}insertarDomicilio?nombreEmpresa=${empresa}`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(domicilioBody),
          credentials: "include"
        }
      );

      if (!insertarDomicilioResponse.ok) {
        throw new Error(
          `Error al insertar domicilio en medidores: ${insertarDomicilioResponse.status}`
        );
      }

      return data;
    } catch (error) {
      console.error("Error al crear producto:", error);
      alert(error.message || "Error al crear producto");
    }
  };

  const createProductAdyacenteAPI = async ({
    idProducto,
    productos
  }) => {
    try {
      const queryParams = new URLSearchParams({
        idProducto, 
        productos: JSON.stringify(productos)
      });

      const response = await fetch(
        `${baseUrl}createProductoAdyacente?${queryParams.toString()}`,
        {
          method: "POST",
          headers: headerText,
        }
      );

      const data2 = await response.json();

      if (!response.ok) {
        throw new Error(data2.mensaje || "Error al crear producto adyacente");
      }
      
      return data2;
    } catch (error) {
      console.error("Error al crear producto:", error);
      alert(error.message || "Error al crear producto");
    }
  };

  const updateProductAdyacenteAPI = async ({
    idProducto,
    productos // Agregar parámetro con valor por defecto
  }) => {
    try {
      const queryParams = new URLSearchParams({
        idProducto, 
        productos: JSON.stringify(productos)
      });

      const response = await fetch(
        `${baseUrl}updateProductoAdyacente?${queryParams.toString()}`,
        {
          method: "POST",
          headers: headerText,
        }
      );

      const data2 = await response.json();

      if (!response.ok) {
        throw new Error(data2.mensaje || "Error al actualizar producto adyacente");
      }
      
      return data2;
    } catch (error) {
      console.error("Error al actualizar producto:", error);
      alert(error.message || "Error al actualizar producto");
    }
  };

  const deshabilitarProductAdyacenteAPI = async ({
    idProducto
  }) => {
    try {
      const response = await fetch(
        `${baseUrl}desactivarProductoAdyacente?idProducto=${idProducto}`,
        {
          method: "POST",
          headers: headerText,
        }
      );
      const data3 = await response.json();
      if (!response.ok) {
        throw new Error(data3.mensaje || "Error al actualizar producto adyacente");
      }
      //alert("Producto adyacente actualizado exitosamente.");
      return data3;
    } catch (error) {
      console.error("Error al actualizar producto:", error);
      alert(error.message || "Error al actualizar producto");
    }
  };

  const handleDeleteUnionProducto = () => {
    // Validación previa: asegurar que hay un producto seleccionado y que tiene id
    if (!selectedProduct?.id) {
      alert("Selecciona un producto válido para desactivar la unión.");
      return;
    }
  
    confirmDialog({
      message: "¿Estás seguro de que deseas desactivar esta union de productos?",
      header: "Confirmar Desactivación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",
      accept: async () => {
        try {
          const body = new URLSearchParams({
            idProducto: selectedProduct.id
          });

          // Llamada al servicio con el id
          const response = await fetch(`${baseUrl}deleteUnionProducto`, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            },
            body,
            credentials: "include",
          });

          if (!response.ok) {
            const errText = await response.text();
            throw new Error(errText || "Error al desactivar la union de productos");
          }
        } catch (error) {
          console.error("Error al desactivar el producto:", error);
          alert(`Error: ${error.message}`);
        } finally {
          setShowEditDialog(false);
          alert("Producto desactivado exitosamente.");
          await fetchData();
        }
      },
    });
  };

  // const handleDeleteProducto = (productoId) => {
  //   confirmDialog({
  //     message: "¿Estás seguro de que deseas desactivar este producto?",
  //     header: "Confirmar Desactivación",
  //     icon: "pi pi-exclamation-triangle",
  //     acceptLabel: "Sí",
  //     rejectLabel: "No",
  //     accept: async () => {
  //       try {
  //         // Call the API to deactivate the product
  //         await deactivateProductAPI(productoId);
  //         alert("Producto desactivado exitosamente.");
  //         await fetchData();
  //       } catch (error) {
  //         console.error("Error al desactivar el producto:", error);
  //       }
  //     },
  //   });
  // };

  // const handleActivateProducto = (productoId) => {
  //   confirmDialog({
  //     message: "¿Estás seguro de que deseas activar este producto?",
  //     header: "Confirmar Activación",
  //     icon: "pi pi-exclamation-triangle",
  //     acceptLabel: "Sí",
  //     rejectLabel: "No",
  //     accept: async () => {
  //       try {
  //         // Call the API to activate the product
  //         await activateProductAPI(productoId);
  //         alert("Producto activado exitosamente.");
  //         // Fetch all products again after activating
  //         await fetchData();
  //       } catch (error) {
  //         console.error("Error al activar el producto:", error);
  //       }
  //     },
  //   });
  // };

  // const activateProductAPI = async (productoId) => {
  //   const response = await fetch(
  //     `${baseUrl}activateProducto?id=${productoId}`,
  //     {
  //       method: "PUT",
  //     }
  //   );
  //   if (!response.ok) {
  //     throw new Error("Error activating the product");
  //   }
  //   return await response.json();
  // };

  // const deactivateProductAPI = async (productoId) => {
  //   const response = await fetch(`${baseUrl}deleteProducto?id=${productoId}`, {
  //     method: "DELETE",
  //   });
  //   if (!response.ok) {
  //     throw new Error("Error deactivating the product");
  //   }
  //   return await response.json();
  // };

  useEffect(() => {
    obtenerEmpresas();
  }, [baseUrl]);

  useEffect(() => {
    if (empresa) {
      setGlobalFilterValue('');
      fetchData();
      fetchTipoProductoByEmpresa(empresa);
    }
  }, [empresa, baseUrl]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-between">
        <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={(e) => {
              const upperCaseValue = e.target.value.toUpperCase();
              onGlobalFilterChange({ target: { value: upperCaseValue } });
            }}
            placeholder="Buscar por Descripción"
          />
        </span>
        <span className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          {productos?.length} productos
        </span>
      </div>
    );
  };

  const header = renderHeader();

  return (
    <div className="grid">
      <Toast ref={toast} />
      <div className="col-12">
        <div className="card">
          <h4>Gestión de Productos</h4>
          <div className="p-field">
            <label htmlFor="empresa">Seleccione Empresa: </label>
            <Dropdown
              id="empresa"
              value={empresa}
              onChange={(e) => setEmpresas(e.value)}
              options={listaEmpresas}
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione Empresa"
              className="p-inputtext-sm"
              style={{ borderRadius: "4px" }}
            />
          </div>
        </div>
      </div>
      {empresa && (
        <>
          <div className="col-12">
            <div className="card">
              <>
                {loadingInicial ? (
                  <>
                    <Loader />
                  </>
                ) : (
                  <>
                    <Button
                      label="Crear Producto"
                      icon="pi pi-plus"
                      className="p-button p-component mr-2 p-button-rounded p-button-primary mt-3"
                      onClick={() => setDisplayDialog(true)}
                      disabled={loadingInicial}
                      raised
                    />
                    <Button
                      label="Asociar Subproducto"
                      icon="pi pi-fw pi-tags"
                      className="p-button p-component mr-2 p-button-rounded p-button-info mt-3"
                      onClick={() => setDisplayDialogProductoSubproducto(true)}
                      disabled={loadingInicial}
                      raised
                    />
                    <Button
                      label="Unir Productos"
                      icon="pi pi-link"
                      className="p-button p-component mr-2 p-button-rounded p-button-help mt-3"
                      onClick={() => setDisplayDialogCombinatoria(true)}
                      disabled={loadingInicial}
                      raised
                    />

                    <TableProductos
                      header={header}
                      productos={productos}
                      loading={loadingInicial}
                      globalFilterValue={globalFilterValue}
                      tipoProductoOptions={tipoProductoOptions}
                      handleEditProducto={handleEditProducto}
                      className="mt-3"
                    />

                    <FormCrearProducto
                      displayDialog={displayDialog}
                      setDisplayDialog={setDisplayDialog}
                      producto={producto}
                      setProducto={setProducto}
                      tipoProductoOptions={tipoProductoOptions}
                      handleCreateProducto={handleCreateProducto}
                      baseUrl={baseUrl}
                      empresa={empresa}
                      nombreEmpresa={nombreEmpresa}
                      loading3={loading3}
                    />

                    <FormEditarProducto 
                      showEditDialog = {showEditDialog}
                      setShowEditDialog = {setShowEditDialog}
                      descripcion = {descripcion}
                      idTipo = {idTipo}
                      union = {union}
                      id = {id}
                      setDescripcion = {setDescripcion}
                      metraje = {metraje}
                      setMetraje = {setMetraje}
                      adyacentes = {adyacentes}
                      setAdyacentes = {setAdyacentes}
                      productos = {productos} 
                      loading = {loadingInicial}
                      handleSaveProducto = {handleSaveProducto}
                      selectedProduct = {selectedProduct}
                      fichaRef = {fichaRef}
                      producto={producto}
                      setProducto={setProducto}
                      tipoProductoOptions={tipoProductoOptions}
                      handleDeleteUnionProducto={handleDeleteUnionProducto}
                    />
                    
                    <FormCrearComboProductos 
                      empresa={empresa}
                      listaEmpresas={listaEmpresas}
                      loading={loadingInicial}
                      setLoading={setLoading}
                      baseUrl={baseUrl}
                      nombreEmpresa={nombreEmpresa}
                      setProductos={setProductos}
                      productoCombinado={productoCombinado}
                      setProductoCombinado={setProductoCombinado}
                      setProductosFiltrados={setProductosFiltrados}
                      displayDialogCombinatoria={displayDialogCombinatoria}
                      setDisplayDialogCombinatoria={setDisplayDialogCombinatoria}
                      productosFiltrados={productosFiltrados}
                      fetchDataProductos={fetchData}
                      toast={toast}
                    />

                    <FormCrearProductoSubproducto
                      empresa={empresa}
                      listaEmpresas={listaEmpresas}
                      loading={loading}
                      setLoading={setLoading}
                      baseUrl={baseUrl}
                      nombreEmpresa={nombreEmpresa}
                      productos={productos}
                      setProductos={setProductos}
                      displayDialogProductoSubproducto={displayDialogProductoSubproducto}
                      setDisplayDialogProductoSubproducto={setDisplayDialogProductoSubproducto}
                      fetchData={fetchData}
                    />

                    <ConfirmDialog/>
                    
                  </>
                )}
              </>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default MantenedorProductos;